// PDF Header.jsx
import styles from "./pdf.module.css";
const Header = () => {
  return (
    <>
    <header className={styles.pdf_header}>
      <div className={styles.pdf_header_left}>
        <p>
          <span className={styles.pdf_red} >ESPAC</span>{" "}
          <span className={styles.pdf_black} >|</span> ARN – 110398
          <br />
          AMFI Registered Mutual Fund Distributor
          <br />
          Life, Health & General Insurance Distributor
        </p>
      </div>

      <div className={styles.pdf_header_right}>
        <img
          src="https://espac.in/wp-content/uploads/2025/10/tm-01-1.svg"
          alt="ESPAC Logo"
          crossOrigin="anonymous"
        />
      </div>
    </header>
    </>
  );
};

export default Header;